<template>

    <div class='header'>
      <router-link to="/">
          <div class="logo">
            <img src="@/assets/logos/hidden-field-logo-icon.svg" alt="hiddenfield_logo">
          </div>
          <div class='hf_name'>Hidden Field</div>
      </router-link>

      <hf-menu class='burger_menu' width='100%' right />

      <div v-if="showLinks" class="nav">
        <router-link to="/#services">
          <div class="item">Services</div>
        </router-link>
        <router-link to="/#about">
          <div class="item">Who we are</div>
        </router-link>
        <router-link to="/#projects">
          <div class="item">Case studies</div>
        </router-link>
        <router-link to="/#testimonials">
          <div class="item">Our Clients</div>
        </router-link>
        <router-link to="/#contact">
          <div class="cta">Get in touch</div>
        </router-link>
      </div>
    </div>

</template>

<script>
export default {
    props: {
      showLinks: Boolean,
    },
    methods: {
      closeMenu() {
        this.$emit('closeMenu');
        console.log('close')
      }
    }
}
</script>
<style lang="scss" scoped>

  @import "@/scss/_variables";

  .header {
    background-color: $white ;
    height: 66px;
    overflow: hidden;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 16px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 1.67px;
    position: sticky;
    top: 0;
    left: 0;
    box-shadow: 0px 0px 10px 6px rgba(0,0,0,0.1);
    z-index:998;

    @media screen and (min-width: $screen-min) {
      font-size: 11px;
    }
  }

  .header .logo {
    float: left;
    margin: 10px;
  }

  .header .hf_name {
    float: left;
    margin-top: 22px;

    @media screen and (min-width: $screen-min) {
      margin-top: 25px;
    }
  }

  .header .nav {
    float: right;
    text-transform: uppercase;
    display: none;
    margin-right: 10px;
    // Medium and up
    @media screen and (min-width: 800px) {
      display: block;
      margin-right: 25px;
    }
  }

  .header .nav .item {
    width: 10em;
    float: left;
    margin-top: 25px;
    margin-right: 12px;

    @media screen and (min-width: $screen-min) {
      margin-top: 26px;
    }
  }

  .header .nav .cta {
    text-align: center;
    float: left;
    margin-top: 10px;
    width: 144px;
    height: 39px;
    line-height: 39px;
    border-radius: 19.5px;
    background-color: $light-blue;
    color: white;
  }

  .burger_menu {

    display: none;
    text-align: center;

    // Medium and up, no, no
    @media screen and (min-width: 800px) {
      display: none;
    }
  }

  .bm-burger-button {
    height: 31px;
  }

  .bm-burger-bars {
    height: 3px;
    background-color: black;
  }

  a {
    text-decoration: none;
  }

  a:link {
    color: black;
  }

  a:visited {
    color: black;
  }

  a:hover {
    color: $light-blue;
  }

  a:active {
    color: $blue;
  }

  .menu_item {
    color: white;
    font-size: 32px;
    margin: 10px;
  }


</style>
